import * as Scrivito from "scrivito";

const YouTubeWidget = Scrivito.provideWidgetClass("YouTubeWidget", {
  attributes: {
    title: "string",
    videoUrl: "string",
    aspectRatio: [
      "enum",
      { values: ["21:9", "16:9", "4:3", "1:1", "3:4", "9:16"] },
    ],
  },
});

export default YouTubeWidget;
